import React from "react";
import { observer } from "mobx-react-lite";
import Select from "react-select";

const MediaFileSelectView = observer(({ store, experienceFieldName, notify, filterFormats }) => {
    // Force the value to be null when selected is undefined to ensure React Select clears
    const selectValue = store?.selected === undefined ? null : store?.selected;

    // When filterFormats is provided, only show files whose format matches the allowed list.
    // We check both the fileFormat field and the file name extension (case-insensitive)
    // to handle cases where fileFormat may be empty or stored differently.
    const filterByFormat = (opt) => {
      const fileFormat = (opt.fileFormat || '').toLowerCase();
      const nameExtension = (opt.name || '').split('.').pop().toLowerCase();
      return filterFormats.includes(fileFormat) || filterFormats.includes(nameExtension);
    };
    const options = filterFormats
      ? (store?.options() || []).filter(filterByFormat)
      : store?.options();

    return (<>
      <Select
            sm={10}
            className="react-select-container"
            classNamePrefix="react-select"
            options={options}
            id="selected"
            value={selectValue}
            onInputChange={(data) => {
                store?.search(data);
            }}
            onChange={(data) => {
                store?.select(data,experienceFieldName, notify);
            }}
            getOptionLabel={option => option.label}
            getOptionValue={option => option.uuid}
            placeholder="Select"
            isClearable={true}
          />
      </>
    );
});

export default MediaFileSelectView;
